// extracted by mini-css-extract-plugin
export var catalogue = "index-module--catalogue--0-Nu3";